import React, { FC, ReactNode } from 'react';
import styled, { ThemeProvider } from 'styled-components';
import { globalTheme } from '@cld/component-theme';
import GlobalStyles from '@cld/global-style';
import { theme } from '../../theme';
import { CodeTabSectionProps } from '../../types';
import { Header } from './Header';
import { Sidebar, SIDEBAR_WIDTH } from './Sidebar';

export const WIDGET_HEIGHT = 760;

const Root = styled.div`
  display: flex;
  flex-direction: column;
  height: 100vh;
`;

const Content = styled.div`
  flex: 1;
  height: 100%;
  position: relative;
`;

const WidgetContainer = styled.div`
  margin-left: ${SIDEBAR_WIDTH}px;
  padding: ${globalTheme.spacing.xl};
  height: ${WIDGET_HEIGHT}px;
`;

export { CodeTabSectionProps };

export interface LayoutProps {
  title: string,
  headerContents?: ReactNode,
  onClose: () => void;
  settingsTab: ReactNode;
  codeTabSections: FC<CodeTabSectionProps>[];
  widget: ReactNode;
}

export const Layout: FC<LayoutProps> = ({ title, headerContents, onClose, settingsTab, codeTabSections, widget }) => (
  <ThemeProvider theme={theme}>
    <GlobalStyles />
    <Root>
      <Header title={title} onClose={onClose}>
        {headerContents}
      </Header>
      <Content>
        <Sidebar settingsTab={settingsTab} codeTabSections={codeTabSections} />
        <WidgetContainer>
          {widget}
        </WidgetContainer>
      </Content>
    </Root>
  </ThemeProvider>
);
